import Buttons from "../Buttons/Buttons";
import { Link } from 'react-router-dom';
import './bannerCasos.css';
import { conMiniaturas } from '../../conexiones/varConexiones';

const Bannercaso = (props) => {
    const img_banner = conMiniaturas+props.id+'/thum_'+props.thum;
    const imgCaso = img_banner.replace(/\s/g,"%20");
    const router = props.textos.proyecto.replace(/\s/g,'-')
    return(
        <div className="BannerCaso">
            <div style={{backgroundImage:`url("${imgCaso}")`}} alt="Imagen de caso de estudio" className="BannerCaso-image"></div>
            <div className="BannerCaso-textos">
                <div className="BannerCaso-textos-main">
                    <h3 className="BannerCaso-name">{props.textos.proyecto}</h3>
                    <p className="BannerCaso-desc">{props.textos.descripcion}</p>
                </div>
                <div className="BannerCaso-textos-boton">
                    <Link className='Link' to={`/Casos/${props.id}/${router}`}>
                        <Buttons type={'primary'} onClick={''} cta={props.textos.cta}></Buttons>
                    </Link>
                </div>
                
            </div>
        </div>
    )
}

export default Bannercaso;